if (!customElements.get('shipping-calculator')) {
  class ShippingCalculator extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }

    handleClick(evt) {
      if (evt.target.closest('.cart-shipping-calculator__button')) {
        this.handleSubmit(evt);
      }
    }

    init() {
      this.button = this.querySelector('.cart-shipping-calculator__button');
      this.country = this.querySelector('.js-country-select');
      this.province = this.querySelector('.js-province-select');
      this.zip = this.querySelector('.js-zip-input');
      this.rates = this.querySelector('.js-rates');
      this.errors = this.querySelector('.js-errors');
      this.initialised = true;
    }

    /**
     * Handles submission of the rates calculator.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      evt.preventDefault();
      this.init();

      if (!this.button || !this.zip || !this.country) return;

      const buttonText = this.button.innerText;
      this.errors.hidden = true;
      this.rates.hidden = true;
      this.button.disabled = true;
      this.button.innerText = 'Calculando...';

      const provinceValue = this.province && this.province.value ? this.province.value : '';
      const params = `shipping_address[zip]=${encodeURIComponent(this.zip.value)}&shipping_address[country]=${encodeURIComponent(this.country.value)}&shipping_address[province]=${encodeURIComponent(provinceValue)}`;

      try {
        const cartUrl = theme.routes.cart_url || theme.routes.cart;
        const response = await fetch(`${cartUrl}/shipping_rates.json?${params}`);
        const data = await response.json();

        if (response.ok) {
          this.showRates(data);
        } else {
          this.showErrors(data);
        }
      } catch (error) {
        console.error('Shipping calculator error:', error);
      } finally {
        this.button.innerText = buttonText;
        this.button.disabled = false;
      }
    }

    /**
     * Formats and shows a list of available shipping rates.
     * @param {object} data - Response data.
     */
    showRates(data) {
      const headingEl = this.rates.querySelector('.js-rates-heading');
      const textEl = this.rates.querySelector('.js-rates-text');
      textEl.innerHTML = '';

      if (data.shipping_rates && data.shipping_rates.length) {
        let rates = '';

        data.shipping_rates.forEach((rate) => {
          let formattedRate;
          if (rate.price > 0) {
            formattedRate = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(rate.price);
          } else {
            formattedRate = 'Grátis'
          }

          let deliveryDays;
          if (rate.delivery_days[0] === 1) {
            deliveryDays = `${rate.delivery_days[0]} dia útil`
          } else {
            deliveryDays = `${rate.delivery_days[0]} dias úteis`
          }

          rates += `<li><p>${rate.name}: <b>${formattedRate}</b></p><p>${deliveryDays}</p></li>`;
        });

        headingEl.hidden = false;
        textEl.innerHTML = `<ul class="styled-list">${rates}</ul>`;
      } else {
        headingEl.hidden = true;
        textEl.innerHTML = 'Não há taxas de entrega disponíveis';
      }

      this.rates.hidden = false;
    }

    /**
     * Formats and shows errors relating to rates retrieval.
     * @param {object} data - Response data.
     */
    showErrors(data) {
      let errors = '';

      Object.keys(data).forEach((key) => {
        errors += `<li>${data[key]}</li>`;
      });

      this.errors.querySelector('.js-errors-text').innerHTML = `<ul class="styled-list">${errors}</ul>`;
      this.errors.hidden = false;
    }
  }

  customElements.define('shipping-calculator', ShippingCalculator);
}
